(() => {
  if (!window.sliderBlockTitles) return;

  // Process each slideshow component separately
  document.querySelectorAll('slideshow-component.disney__carousel').forEach(function(slideshow) {
    const sectionId = slideshow.id.replace('Slider-', '');
    const titles = window.sliderBlockTitles[sectionId];
    
    if (!Array.isArray(titles) || !titles.length) return;

    // Update button titles for each slide within this slideshow
    slideshow.querySelectorAll('.slider-inline-controls').forEach(function(control) {
      const prevSpan = control.querySelector('.slider-inline-title--prev');
      const nextSpan = control.querySelector('.slider-inline-title--next');
      const slideEl = control.closest('.slideshow__slide');
      if (!slideEl || !slideEl.id) return;

      const slideIndex = parseInt(slideEl.id.split('-').pop(), 10) - 1;
      const total = titles.length;
      const prevTitle = titles[(slideIndex - 1 + total) % total];
      const nextTitle = titles[(slideIndex + 1) % total];

      if (prevSpan) prevSpan.textContent = prevTitle;
      if (nextSpan) nextSpan.textContent = nextTitle;
    });

    // Click functionality for per-slide prev/next
    slideshow.querySelectorAll('.slider-inline-prev, .slider-inline-next').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        const slideIndex = parseInt(this.dataset.slideIndex, 10);
        const total = titles.length;
        let targetIndex;

        if (this.classList.contains('slider-inline-prev')) {
          targetIndex = (slideIndex - 1 + total) % total;
        } else {
          targetIndex = (slideIndex + 1) % total;
        }

        const targetSlide = slideshow.querySelector(`[id^="Slide-"][id$="-${targetIndex + 1}"]`);
        if (targetSlide) {
          targetSlide.scrollIntoView({ block: 'nearest', inline: 'start' });
        }
      });
    });
  });
})();